module.exports = ".resultBlock:nth-child(1){padding-left:250px}.resultBlock:nth-child(3){padding-right:230px}\n"